import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SettingsService } from '@app/core/settings/settings.service';
import { loadProgram } from '@app/core/store/programs/actions';
import { selectError, selectProgram } from '@app/core/store/programs/selectors';

@Injectable({
  providedIn: 'root',
})
export class ProgramsFacade {
  public readonly program$ = this.store.select(selectProgram);
  public readonly error$ = this.store.select(selectError);

  constructor(protected store: Store,
              protected settingsService: SettingsService) { }

  public loadProgram(id: number): void {
    this.settingsService.getSettingsOnce().subscribe(() =>
      this.store.dispatch(loadProgram({ id })),
    );
  }
}
